import { Component, OnInit, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncionService } from '../../servicios/funcion.service';
import { Producto, Metatags, addZoom } from '../../utilidades/utilidades';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment.prod';
import { Meta } from '@angular/platform-browser';
declare var $: any;

@Component({
	selector: 'app-producto',
	templateUrl: './producto.component.html',
	styleUrls: ['./producto.component.css']
})
export class ProductoComponent implements OnInit {

	shareObj = {
        href: "",
        hashtag:"#SomosFamilia"
    };

	newObjectoAlerta:any = { nombre:"" };

	newProducto:Producto = {
		id:0,
		descripcionCorta:"",
		descripcionLarga:"",
		​​inventario:[],
		metaDescripcion:"",
		marca:"",
		modelo:"",
		nombre:"",
		divisa:{},
		onWishlist:false,
		caracteristicas:[],
		unidad:{}
	};
	newImageZoom:addZoom;

	currentInventarioDetalle:any = {};
	currentInventario:any = {};

	tieneColores:boolean = false;
	tieneTallas:boolean = false;

	currentDate:Date = new Date();
	currentDay:string = "";
	limitHour:string = "";
	

	galeria:any[] = [];
	currentImage:any = { base64:"" };

	currentProducto:any = { 
		cantidad:1,
		color:{},
		talla:{}
	};

	tituloTalla:string = "Seleccione una talla";
	tituloColor:string = "Seleccione un color";

	tituloRelacionados:string = "Te pordría Interesar";
	listaRelacionados:any[] = [];

	listaResenias:any[] = [];
	listaPreguntas:any[] = [];

	paginacion:any = {
		max:3, offset:0, orden:{ id:1, nombre:"Más reciente" }, incio:0, fin:0, totalPaginas:0,
		currentOffset:0, currentItems:3
	}
	permiteEnvioMismoDia:Boolean = true;

	permisos:boolean = false;

	listaInventario:any[] = [];
	listaDetaleInventario:any[] = [];


	newUser:any = {};


	anchoCarousel:number = 0;
	numberOfShow:number = 4;

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.fnChangeCarousel( event.target.innerWidth );
	}

	fnChangeCarousel( anchoWindow ){
		if (isPlatformBrowser(this.platformId)) {
			this.anchoCarousel = anchoWindow;
			this.numberOfShow = 4;
			if( anchoWindow === 768 && anchoWindow <= 1023 ){
				this.numberOfShow = 3;
			}else if( anchoWindow < 768 ){
				this.numberOfShow = 1;
				if(this.newImageZoom){
					this.newImageZoom.fnStop();
				}
			}
			this.fnCalcularPaginasResenia( anchoWindow );
		}
	}


	fnCargarInformacionProducto(){
		this.newActivatedRoute.paramMap.subscribe( (response:any) => {

			var newRequest = { producto: { alias:response.params.alias } };
			var newPeticion = decodeURI(newRequest.producto.alias).split(" ");
			this.newFuncionService.fnInformacionProducto( newRequest )
			.subscribe( (response:any) => {
				if( response.success ){
					this.newProducto = response.informacion;
					this.newTitle.setTitle(`Producto ${this.newProducto.nombre}`);
					this.listaInventario = this.newProducto.inventario;

					this.listaInventario.forEach( (newItem)=>{
						newItem.detalles.forEach( (newDetalle)=>{
							if( newPeticion[0] ===  newDetalle.skuProveedor ){
								this.currentImage = {url:newItem.fotografia};
								this.currentInventario = newItem;
							}
						});
					});

					let newMetatags:Metatags ={
						title:this.newProducto.nombre,
						description:this.newProducto.metaDescripcion,
						image:this.currentImage.url,
						url:`https://www.pawerful.com${ this.newRouter.url }`,
						robots:'index, follow',
						keywords:"Alimento, mascotas, perros, gatos, juguetes, royal canin, Hill's, Nupec, Science diet, envío exprés, envío express, mascotas CDMX, camas, roedores, resptiles, aves, peces, transportadoras, antipulgas, desparacitante, satiety, support, recovery, lata, weight control, Royal weight control, hidrolized, carnaza, premios para perro, smartbones, petaco, arenero, arbol para gato, petco, +kota, mascotas, la tienda de frida, huellas, animalia, servicio a domicilio, mascotas CDMX, adopciones, feline, sudadera, capa, suéter, alimento premium, alimento seco, alimento húmedo, collares, correas, feline, kitten, a/d, hills, science diet, mobility, urinary, canine, smartsticks, kong, camas para perro, camas para gato, camas para mascota, cangurera perro, óptimo, purina, platos para perro, bebederos para perro, pechera para perro, collares gato, collar, correa",
		    			language:"Spanish",
		    			type:"product",
		    			author:"Pawerful pet shop, S.A. de C.V."
					};
					// this.shareObj.href = `https://www.pawerful.com${ this.newRouter.url }`;

					this.newFuncionService.fnUpdateMetas( newMetatags );

					if( this.listaInventario.length > 1 ){
						this.tieneColores = true;
					}

					this.listaDetaleInventario = this.currentInventario.detalles;
					this.currentInventarioDetalle = this.listaDetaleInventario.find(newItem => newItem.skuProveedor === newPeticion[0]);
					if( this.listaDetaleInventario.length > 1 ){
						this.tieneTallas = true;
					}

					this.currentProducto.color = this.currentInventario;
					this.currentProducto.talla = this.currentInventarioDetalle;

					this.cargarPermisosProducto();
					this.fnCargarGaleria();
					this.fnProductosRelacionados();
					this.fnCargarResenias();
					this.fnCargarpreguntas();
				}else{
					this.newRouter.navigate(["404"], { replaceUrl: true });
				}
			});
		});
	};


	constructor( 
		private newFuncionService:FuncionService, 
		private newActivatedRoute:ActivatedRoute, 
		private newRouter:Router, 
		private newMeta:Meta,
		private newTitle: Title,
		@Inject(PLATFORM_ID) private platformId: Object
		){
		
	}

	cargarPermisosProducto(){
		this.newFuncionService.fnPermisosProducto( {producto:{ id:this.newProducto.id }} )
		.subscribe( (response:any) =>{
			this.permisos = response.success;
		});
	}
	

	ngOnInit() {

		this.newRouter.navigate(['.'], { relativeTo: this.newActivatedRoute, queryParams: {} });
		this.newUser = this.newFuncionService.currentUserValue;

		var dd = String(this.currentDate.getDate()).padStart(2, '0');
		var mm = String(this.currentDate.getMonth()).padStart(2, '0');
		this.currentDay = this.newFuncionService.fnGetMes( parseInt(mm) ) + ' ' + dd;
		
		if( this.currentDate.getHours() >= 13 ){
			this.permiteEnvioMismoDia = false;
		}

		if( (this.currentDate.getHours() + 2) > 24 ){
			this.limitHour = "12:" + this.currentDate.getMinutes()
		}else{
			this.limitHour = (this.currentDate.getHours() + 2) + ":" + this.currentDate.getMinutes()
		}

		this.fnCargarInformacionProducto();

		if (isPlatformBrowser(this.platformId)) {
			this.newImageZoom = new addZoom();
			this.fnChangeCarousel( window.innerWidth );
		}

	}


	fnSeleccionColor( newColor ){
		this.currentInventario = newColor;
		this.listaDetaleInventario = this.currentInventario.detalles;
		this.currentInventarioDetalle = this.listaDetaleInventario[0];
		if( this.listaDetaleInventario.length > 1){
			this.tieneTallas = true;
		}
		this.currentProducto.color = this.currentInventario;
		this.newFuncionService.fnegistrarVisita({sku:this.listaDetaleInventario[0].sku});

		var identificador =  `${this.currentInventarioDetalle.skuProveedor} ${this.newProducto["alias"]}`;
		this.newRouter.navigate([ '/producto', encodeURI(identificador) ]);
	}

	fnSeleccionTalla( newTalla ){
		this.currentInventarioDetalle = newTalla;
		this.currentProducto.talla = this.currentInventarioDetalle;
		this.newFuncionService.fnegistrarVisita({sku:this.currentProducto.talla.sku});
		var identificador =  `${this.currentInventarioDetalle.skuProveedor} ${this.newProducto["alias"]}`;
		this.newRouter.navigate([ '/producto', encodeURI(identificador) ]);
	}


	/* FUNCIONES RELACIONADOS */
	fnProductosRelacionados(){
		this.newFuncionService.fnProductosRelacionados( {producto:{id:this.newProducto.id} } )
		.subscribe( (response:any) =>{
			if( response.success){
				this.listaRelacionados = response.lista;
			}
		});
	}

	/* FUNCIONES GALERIA */
	fnCargarGaleria(){
		this.newFuncionService.fnGaleriaInventario( {inventario:{ id:this.currentInventario.id } } )
		.subscribe( (response:any) =>{
			if( response.success ){
				if( response.galeria.length > 0 ){
					this.galeria = response.galeria;
					if( this.currentImage.url !== "" ){
						this.newImageZoom.fnInit("imgPreview");
						setTimeout(()=>{
							this.newImageZoom.fnRun();
						},500);
					}
				}
			}else{

			}
		});
	}

	fnCambioImagen( currentImage ){
		this.currentImage = currentImage;
	}

	/* FUNCIONES CANTIDADES */
	fnCambiarCantidad( aumento ){
		if( aumento ){
			if( this.currentProducto.cantidad < this.currentInventarioDetalle.stock ){
				this.currentProducto.cantidad = this.currentProducto.cantidad + 1;
			}
		}else{
			if( this.currentProducto.cantidad > 1 ){
				this.currentProducto.cantidad = this.currentProducto.cantidad - 1;
			}
		}
	}

	fnValidateCantidad(){
		if( this.currentProducto.cantidad < 1 || this.currentProducto.cantidad > this.currentInventarioDetalle.stock ){
			this.currentProducto.cantidad = this.currentInventarioDetalle.stock;
			this.newFuncionService.setNewAlerta( environment.alerta.producto.cantidad );
		}
	}

	/* FUNCIONES RESENIAS */
	fnCalcularPaginasResenia( anchoWindow ){
		this.paginacion.max = 2;
		this.paginacion.currentItems = 2;
		if( anchoWindow >= 500 && anchoWindow <=1023 ){
			this.paginacion.max = 2;
			this.paginacion.currentItems = 2;

		}else if( anchoWindow < 500 ){
			this.paginacion.max = 1;
			this.paginacion.currentItems = 1;
		}else{
			this.paginacion.max = 3;
			this.paginacion.currentItems = 3;
		}
		this.paginacion.offset = 0;
		this.paginacion.currentOffset = 0;
		this.paginacion.currentItems = this.paginacion.max;

		this.paginacion.inicio = 1;
		this.paginacion.fin = ( this.listaResenias.length * ( this.paginacion.offset + 1 ));
		if( this.paginacion.offset > 0 ){
			this.paginacion.inicio = (this.paginacion.fin - this.listaResenias.length) + 1;
		}
		this.paginacion.totalPaginas = Math.ceil(this.listaResenias.length / this.paginacion.max);
	}

	fnCargarResenias(){
		this.newFuncionService.fnCragarResenias( {producto:{ id:this.newProducto.id } } )
		.subscribe( (response:any) =>{
			if( response.success ){
				this.listaResenias = response.lista;
				// this.fnCalcularPaginasResenia();
			}else{

			}
		});
	}

	fnCargarpreguntas(){
		this.newFuncionService.fnCargarpreguntas( {producto:{ id:this.newProducto.id } } )
		.subscribe( (response:any) =>{
			if( response.success ){
				this.listaPreguntas = response.lista;
			}else{

			}
		});
	}
	fnPaginarResenias( newPagina ){
		this.paginacion.offset = newPagina;
		if( this.paginacion.offset === 0 ){
			this.paginacion.currentOffset = 0;
			this.paginacion.currentItems = this.paginacion.max;
		}else{
			this.paginacion.currentOffset = ( this.paginacion.offset * this.paginacion.max );
			this.paginacion.currentItems = ( this.paginacion.offset * this.paginacion.max ) + this.paginacion.max;
		}
	}

	fnErrorPaginador( newError ){
		this.newFuncionService.setNewAlerta( newError );
	}

	/* FUNCIONES WISHLIST */
	fnWishlist( operacion ){
		this.newFuncionService.fnWishlist( { inventarioDetalle:{ id:this.currentInventarioDetalle.id }, registro:operacion } )
		.subscribe( (response:any) =>{
			if( response.success ){
				this.newProducto.onWishlist = operacion;
			}
		});
	}

	/* FUNCIONES CARRITO */
	fnAgregarProductoCarrito(){
		let newRequest = {
			venta:{
				uuid: this.newFuncionService.currentUuidValue,
				producto:{
					id: this.currentInventarioDetalle.id,
					cantidad:this.currentProducto.cantidad,
					precio:this.currentInventarioDetalle.precio,
					descuento:this.currentInventarioDetalle.descuento
				}
			}
		};
	
		this.newFuncionService.fnValidarDisponibilidadProducto( newRequest )
			.subscribe( (response:any) => {
				if( response.success && response.disponible ){
					this.newFuncionService.fnRegistrarProducto( newRequest )
					.subscribe( (response:any) =>{
						if( response ){
							let newMessaje = environment.alerta.venta.carrito.success.mensaje.toString().replace("#nombreProducto#", this.newProducto.nombre);
							this.newFuncionService.setNewAlerta( {
								mensaje: newMessaje,
								titulo: environment.alerta.venta.carrito.success.titulo,
								estilo: environment.alerta.venta.carrito.success.estilo,
								icono: environment.alerta.venta.carrito.success.icono
							} );
							this.newFuncionService.fnTotalProductosCarrito({ venta:{ uuid: this.newFuncionService.currentUuidValue } })
							.subscribe( (response:any) =>{
								if( response.success ){
									this.newFuncionService.currentUserValue.totalProductos = response.totalProductos;
								}
							});
							this.fnCargarInformacionProducto();
						}else{
							this.newFuncionService.setNewAlerta( environment.alerta.venta.carrito.fail );
						}
					});
				}else{
					this.newFuncionService.setNewAlerta( environment.alerta.venta.carrito.nodisponible );
				}
			} )
	}

}
